module.exports = __webpack_public_path__ + "img/ic_lightning.d78997b1.svg";